<template>
  <div class="library-indicator-item">
    <div class="title">
      <EditableLabel
        v-model="indicator.name"
        :placeholder="$t('message.NAME_PH')"
        @input="$emit('edit', 'name', indicator)"
      />
      <span class="field-hint">
        {{ $tc('message.LIBRARY_INDIC_USED_BY', indicator.nTeams, { n: indicator.nTeams }) }}
        {{ teamsDisplay }}
      </span>
    </div>
    <div class="average">
      <IntCheckbox
        v-model="indicator.isAverage"
        :title="$t('message.LIBRARY_INDIC_USE_AVERAGE')"
        @input="$emit('edit', 'isAverage', indicator)"
      />
      <HelperButton :content="$t('message.LIBRARY_INDIC_AVERAGE_HINT')" />
    </div>
    <div class="options v-centerer">
      <button class="add-button blue" @click="$emit('merge-click')">
        {{ $t('message.LIBRARY_INDIC_MERGE') }}
      </button>
      <button class="add-button blue" @click="displayThemes">
        {{ $t('message.LIBRARY_INDIC_MOVE') }}
      </button>
      <button class="add-button delete reverse" @click="$emit('delete')">
        {{ $t('message.DELETE') }}
        <img src="/images/delete.png" alt="">
      </button>
    </div>
    <EditableLabelRadio
      ref="theme"
      v-model="indicator.theme"
      :items="allIndicators.filter(theme => theme.id !== 0)"
      label-key="name"
      ok-button
      @input="editTheme"
    />
  </div>
</template>

<script>
// Components
import EditableLabel from '@/components/editable-label.vue';
import EditableLabelRadio from '@/components/editable-label-radio.vue';
import HelperButton from '@/components/helper-button.vue';
import IntCheckbox from '@/components/int-checkbox.vue';
// Utils
import { decodeHTML } from '@/utils/main';

/** Item in the indicators library */
export default {
  name: 'LibraryIndicatorItem',
  components: {
    EditableLabel,
    EditableLabelRadio,
    HelperButton,
    IntCheckbox,
  },
  props: {
    indicator: {
      type: Object,
      required: true,
    },
    allIndicators: {
      type: Array,
      default: () => [],
    },
    allTeams: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    teamsDisplay() {
      if (this.indicator.nTeams === 0) {
        return '';
      }
      const tstr = this.allTeams
        .filter(t => this.indicator.teams.includes(t.id))
        .map(t => decodeHTML(t.name))
        .join(', ');
      return `(${tstr})`;
    },
  },
  methods: {
    /** Edit themes */
    displayThemes() {
      this.$refs.theme.edit();
    },
    editTheme() {
      this.$emit('edit', 'theme', this.indicator);
    },
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/vars.scss";

.library-indicator-item {
  background: white;
  padding: 5px 10px;
  margin-bottom: 5px;

  .title > * {
    vertical-align: top;

    &.editable-label {
      display: inline-block;
      min-width: 100px;
    }
    &.field-hint {
      line-height: 1.8em;
      margin-left: 12px;
    }
  }
  .average > * {
    vertical-align: middle;

    &.checkbox {
      padding: 2px 0px;

      .tick {
        width: 13px;
        height: 13px;
        margin-right: 7px;

        img.background {
          width: 13px;
          height: 13px;
        }
      }
    }
    &.help-icon {
      width: 17px;
      height: 17px;
      margin-left: 7px;
    }
  }
  .editable-label-radio {
    position: absolute;
    top: -100%;
  }
  .options {
    overflow: hidden;
    justify-content: space-between;

    button {
      padding: 0px;

      &.delete:hover {
        background: $color-hoverbtn-red;
      }
    }
  }
}

</style>
